import { createSelector } from 'reselect';

export const selectDocumentViewer = (state) => state.documentViewer || {};

export const selectDocumentData = createSelector(
  selectDocumentViewer,
  (documentViewer) => documentViewer.data || {}
);

export const selectDocumentDeviation = createSelector(
  selectDocumentViewer,
  (documentViewer) => documentViewer.deviation || {}
);

export const getAllowControlPrint = createSelector(
  selectDocumentData,
  (documentData) => documentData.AllowControlPrint || false
);

export const getAllowContentDownload = createSelector(
  selectDocumentData,
  (documentData) => documentData.AllowContentDownload || false
);
